import vue from "vue";
import axios from "axios";
/*eslint-disable*/
import qs from "qs";
import router from "@/router";

const baseUrl = window.configs.API_ROOT;
// 拦截请求操作
function transformRequest(data, header) {
  //获取token 统一设置
  const token = vue.prototype.$getToken();
  if (token) {
    header.common["token"] = token;
  }
  const _role_tag = vue.prototype.$getQueryVariable("_role_tag");
  if (_role_tag) {
    header.common["_role_tag"] = _role_tag;
  }
  //获取isWx 统一设置 是否是微信浏览器
  // const isWx = localStorage.getItem('isWx');
  // if (isWx) {
  //   header.common['isWx'] = isWx;
  // }
  // 做兼容处理， 图片上传的为multipart/form-data
  if (
    ["multipart/form-data;charset=UTF-8"].indexOf(header["Content-Type"]) >= 0
  ) {
    return data;
  }
  if (["application/json;charset=UTF-8"].indexOf(header["Content-Type"]) >= 0) {
    return JSON.stringify(data);
  }
  return qs.stringify(data);
  // return JSON.stringify(data);
}
// 拦截响应操作
function transformResponse(data) {
  // todo
  return data;
}
const instance = axios.create({
  baseUrl: "",
  timeout: 60000,
  transformRequest: [transformRequest],
  transformResponse: [transformResponse],
  withCredentials: true
});

const _context = vue.prototype;
//const Version = "?v_n=1.0.1";//请求加上版本号   如：?version=1.0.1
const Version = ""; //请求加上版本号   如：?version=1.0.1

//是否当前就在登录页：登录失败(401)时不要再跳 /Login，否则页面重载会把提示冲掉，
//用户看到的就是"点了登录没反应、验证码闪了一下"
function isLoginPage() {
  const url = window.location.pathname + window.location.hash;
  return /\/login(\?|$|\/|#)/i.test(url);
}
// 拦截请求
instance.interceptors.request.use(
  config => {
    const token = vue.prototype.$getToken();
    const hasBoundMobile = localStorage.getItem("hasBoundMobile");  
    const userTypeKey = vue.prototype.$getKeyInfo("userType");
    const userTypeEncoded = vue.prototype.$ls.get(userTypeKey);
    const type = userTypeEncoded
      ? vue.prototype.$Base64.decode(userTypeEncoded)
      : null;
    if (token && hasBoundMobile === "false") {
      setTimeout(() => {
        const path = type == "1" ? "UserCenter" : "TUserCenter";
        router.push({ path });
      }, 100);
    }

    return config;
  },
  error => Promise.reject(error)
);
// 拦截响应
instance.interceptors.response.use(
  response => {
    // 数据返回成功
    // 统一对401 登录过期处理
    let data = null;
    if (typeof response.data === "string") {
      try {
        data = JSON.parse(response.data);
      } catch (error) {
        data = response.data;
      }
      // data = JSON.parse(response.data) ?? response.data
      if (data.code == 401) {
        _context.$message({
          message: data.msg,
          type: "warning"
        });
        _context.$removeToken();
        // _context.$ls.clear();
        if (!isLoginPage()) {
          setTimeout(function() {
            window.location.href = window.location.origin + "/Login";
            // window.location.href = vue.prototype.$baseUrl;
            // localStorage.removeItem('TOKEN');
          }, 500);
        }
      }
    } else {
      data = response;
    }
    return Promise.resolve(data);
  },
  error => {
    if (error.response) {
      let ret = JSON.parse(error.response.data);
      if (ret.code == 401) {
        _context.$message({
          message: ret.msg,
          type: "warning"
        });
        _context.$removeToken("token");
        if (!isLoginPage()) {
          setTimeout(function() {
            window.location.href = window.location.origin + "/Login";
          }, 500);
        }
      } else {
        _context.$message({
          message: ret.msg,
          type: "error"
        });
      }
      // return Promise.resolve(ret)
    }
    return Promise.reject(error);
  }
);

// 导出两个操作
// get 操作
export function get(url, params, option) {
  return new Promise((resolve, reject) => {
    instance
      .get(baseUrl + url + Version, {
        params,
        ...option
      })
      .then(ret => {
        // todo
        resolve(ret);
      })
      .catch(err => {
        // todo
        reject(err);
      });
  });
}
// post 操作
export function post(url, params, option) {
  return new Promise((resolve, reject) => {
    instance
      .post(baseUrl + url + Version, params, option)
      .then(ret => {
        // todo
        resolve(ret);
      })
      .catch(err => {
        // todo
        reject(err);
      });
  });
}

// post 操作
export function postJSON(url, params, option) {
  return new Promise((resolve, reject) => {
    instance
      .post(baseUrl + url + Version, params, {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        ...option
      })
      .then(ret => {
        // todo
        resolve(ret);
      })
      .catch(err => {
        // todo
        reject(err);
      });
  });
}
//
// post 操作
export function posts(url, params, option) {
  return new Promise((resolve, reject) => {
    instance
      .post(url + Version, params, option)
      .then(ret => {
        // todo
        resolve(ret);
      })
      .catch(err => {
        // todo
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/common/request.js